import { useTranslation } from "react-i18next";
import { Input } from "@/uikit";
import { FixButton } from "@/elements-react/fix-button";
import classNames from "classnames";
import style from "./form.module.scss";
import accountIcon from "@/assets/form/account.svg";
import mailIcon from "@/assets/form/mail.svg";
import phoneIcon from "@/assets/form/phone.svg";
import { Icon } from "@/elements-react/fix-icon";
import { FixUpload, FixUploadRef } from "@/elements-react/fix-upload";
import { useFormSendListCommon } from "@/elements-react/form-send-list/FormCommon";
import { Templates, useTemplate } from "@/util-react/template";
import React from "preact/compat";
import { useRef } from "preact/hooks";
import { FormSuccessState } from "@/elements-react/form-success-state";

const FormSendList = () => {
  const { t } = useTranslation();
  const { formData, formErrors, isLoading, changeHandler, handleFileUpload, handleSubmit, isSuccess, setFile, setIsSuccess, serverError } =
    useFormSendListCommon();
  const uploadRef = useRef<FixUploadRef>(null);

  const handleSubmitForm = () => {
    handleSubmit();
    if (uploadRef.current) {
      uploadRef.current.clear();
    }
  };

  return (
    <div className={classNames(style.mobile, style.container)}>
      <div className={classNames(style.leftContainer)}>
        <div className={classNames(style.textContainer)}>
          <div>
            <h2>
              <p className={classNames(style.titleTop)}>{t("form.sendList.title", "Send us your list — get our offer")}</p>
            </h2>
          </div>
          <div className={classNames(style.description)}>
            {t("form.sendList.description", "We’ll review it and quickly get back to you with the best prices and delivery options")}
          </div>
        </div>
      </div>
      <div className={classNames(style.rightContainer)}>
        {!isSuccess && (
          <form className={classNames(style.formGroup)}>
            <div className={classNames(style.fieldsGroup)}>
              <div className={classNames(style.fieldsGroup2)}>
                <Input
                  name="companyName"
                  type="text"
                  placeholder={t("form.sendList.placeholder.companyName", "Your name/Company name")}
                  value={formData.companyName}
                  onChange={changeHandler}
                  customError={formErrors.companyName}
                  required
                  icon={<Icon width={16} src={accountIcon} />}
                  iconPosition="prefix"
                />

                <Input
                  name="email"
                  type="email"
                  placeholder={t("form.sendList.placeholder.email", "Email")}
                  value={formData.email}
                  onChange={changeHandler}
                  customError={formErrors.email}
                  required
                  icon={<Icon width={16} src={mailIcon} />}
                  iconPosition="prefix"
                />

                <Input
                  name="phone"
                  type="tel"
                  placeholder={t("form.sendList.placeholder.phone", "Phone number")}
                  value={formData.phone}
                  onChange={changeHandler}
                  customError={formErrors.phone}
                  required
                  icon={<Icon width={16} src={phoneIcon} />}
                  iconPosition="prefix"
                />
              </div>
              <FixUpload ref={uploadRef} type="file" buttonText={t("form.sendList.chooseFile", "Choose file")} onUpload={handleFileUpload} onReset={() => setFile(null)} />
            </div>

            {serverError && (
              <p className={style.serverError} role="alert">
                {serverError}
              </p>
            )}

            <FixButton type="submit" variant="primary" size="large" onClick={handleSubmitForm} disabled={isLoading} loading={isLoading} fullWidth>
              {t("form.sendList.submit", "Send")}
            </FixButton>
          </form>
        )}
        {isSuccess && <FormSuccessState onClick={() => setIsSuccess(false)} />}
      </div>
    </div>
  );
};

const templates: Record<Templates, React.ComponentType | null> = {
  [Templates.DEFAULT]: null,
  [Templates.BLACK_AND_BLUE]: FormSendList,
};

export const FormSendListMobile = () => {
  const template = useTemplate();
  const TemplatedComponent = templates[template.template ?? Templates.DEFAULT];

  return TemplatedComponent ? <TemplatedComponent /> : null;
};
